export default "__VITE_ASSET__DsUeB2PH__"